module.exports = __webpack_public_path__ + "img/blockLogo.6c828d95.jpg";